/**
 *
 * 菜单状态管理
 *
 * */
import axios from 'axios'
import apiPath from '@config/api.json'

const state = {
  homeTime: new Date().getFullYear() + '', // 二级导航ID(主导航)
  searchDate: new Date().getFullYear() + '',
  model: false,
  title: '',
  headList: [],
  countryList: [],
  warehouseList: [],
  shopList: [],
  sysSourceList: [],
  productTypeList: [],
  modelUrl: '',
  isShowDetail: null,
  showDetail: {},
  method: '',
  companyType: '1'
}

// getters
const getters = {}

// 处理方法
const actions = {
  getItemMenu ({ commit }, obj) {
    commit('setHomeTime', obj)
  },
  getDict ({ commit }, obj) {
    axios({
      method: 'get',
      url: `${apiPath.bigData.dict.getCountryList}`
    }).then(res => {
      res.data.unshift({
        country_code: null,
        country_name: '全部'
      })
      commit('setCountryList', res.data)
    })
    // axios({
    //   method: 'get',
    //   url: `${apiPath.bigData.dict.getShopList}`
    // }).then(res => {
    //   // res.data.unshift('全部店铺')
    //   // commit('setShopList', res.data)
    // })
    axios({
      method: 'get',
      url: `${apiPath.bigData.dict.getSysSourceList}`
    }).then(res => {
      res.data.unshift('全部平台')
      commit('setSysSourceList', res.data)
    })
    axios({
      method: 'get',
      url: `${apiPath.bigData.dict.getWarehouseList}`
    }).then(res => {
      res.data.unshift({
        warehouse_id: '',
        warehouse_name: '全部仓库'
      })
      commit('setWarehouseList', res.data)
    })
    // axios({
    //   method: 'post',
    //   url: `${apiPath.bigData.dict.getProductCategoryList}`,
    //   data: {}
    // }).then(res => {
    //   res.data && res.data.unshift({
    //     name: '全部商品类目'
    //   })
    //   let data = []
    //   for (let item of res.data) {
    //     data.push({
    //       productName: item.name
    //     })
    //   }
    //   commit('setProductTypeList', data.slice(0, 100))
    // })
  },
  getisShowDetail ({commit}, isShow) {
    commit('setIsShowDetail', isShow)
  },
  getShowDetail ({commit}, obj) {
    commit('setShowDetail', obj)
  }
}

// mutations
const mutations = {
  setIsShowDetail (state, isShow) {
    state.isShowDetail = isShow
  },
  setShowDetail (state, obj) {
    state.showDetail = obj
  },
  setHomeTime (state, time) {
    if (time) {
      state.homeTime = time
    } else {
      state.homeTime = ''
    }
  },
  setSearchTime (state, time) {
    if (time) {
      state.searchDate = time + ''
    } else {
      state.searchDate = ''
    }
  },
  setModelInfo (state, data) {
    state.modelUrl = data.modelUrl
    state.headList = data.headList
    state.title = data.title
    state.model = data.model
    state.method = data.method
    state.companyType = data.companyType
  },
  setProductTypeList (state, data) {
    state.productTypeList = data
  },
  setCountryList (state, data) {
    state.countryList = data
  },
  setWarehouseList (state, data) {
    state.warehouseList = data
  },
  setShopList (state, data) {
    state.shopList = data
  },
  setSysSourceList (state, data) {
    state.sysSourceList = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/home.js